import { h, FunctionComponent, ComponentChildren, Fragment } from "preact"; /** @jsx h */
import { clsx } from 'clsx';
import { Authored, IAuthoredProps } from "./List/Authored";


export type ISubheaderProps = {
    children?: ComponentChildren; // e.g. Intro <span classNameNameName="sr-only">(current)</span>
    title: string;
    //linkTo: string; // e.g. ./index.html
    icon?: string;
    iconColor?: string;
    tight?: boolean;
} & IAuthoredProps;

export const Subheader = (props: ISubheaderProps) => {
    return (
        <h5 className="font-weight-bold spanborder" style={ props.tight && { marginBottom: "1rem"} }>
            {
                props.icon && <span
                    className={clsx("iconbox iconsmall rounded-circle text-white border-0", props.iconColor && "bg-" + props.iconColor)}
                    style={{ marginRight: "0.5em"}}
                >
                    <i className={props.icon}></i>
                </span>
            }
            <span style={{width: "calc(100% - 50px)"}}>{ props.title }</span>
        </h5>
    );
}